import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { Pond} from "../../database";
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import SyncableModel from "../../database/SyncableModel";
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import { withBaseModel } from "../extensions/with-base-model"
import JalaAnalytic from "../../utils/jala-analytic"

const PondStoreProps = {
  ...BaseModelStoreProps,

  rfidPond: types.optional(types.array(types.frozen()), []),
  ponds: types.optional(types.array(types.frozen()), []),
}

/**
 * Model description here for TypeScript hints.
 */
export const PondStoreModel = types
  .model("PondStore")
  .props(PondStoreProps)
  .extend(withRootStore)
  .extend(withEnvironment)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof PondStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init() {
      self.initModel();
    },
    async storeToServer(data) {
      return self.storeModelToServer(Pond, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: pond - pond created', { props: data });
          return success;
        });
    },
    async store(data) {
      return this.storeToServer(data);
      // return self.storeModel(Pond, data);
    },
    async updateToServer(model: SyncableModel, data) {
      const { rfid, ...restData } = data;
      return self.updateModelToServer(Pond, model, restData)
        .then((success: boolean) => {
          if (success) {
            JalaAnalytic.log('Mobile app: pond edited', { props: data });
            if (rfid) return this.updateRfid(model, { rfids: [{ id: rfid }] })
            else return this.updateRfid(model, { rfids: [] })
          }
          return success;
        });
    },
    async update(model: SyncableModel, data) {
      return this.updateToServer(model, data);
      // return self.updateModel(Pond, model, data);
    },
    async deleteFromServer(model: SyncableModel) {
      return self.deleteModelFromServer(Pond, model)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile: delete pond', model.toArray());
          return success;
        });
    },
    async delete(model: SyncableModel) {
      return this.deleteFromServer(model);
      // return self.deleteModel(Pond, model);
    },

    async updateRfid(model: SyncableModel, data) {
      this.set('loading', true);
      return self.axios.put(`/ponds/${model.getKey()}`, data)
        .then(() => {
          this.set('error', null);
          this.set('loading', false);
          return true;
        })
        .catch((error) => {
          this.set('error', error);
          this.set('loading', false);
          return false;
        })
    },
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type PondStoreType = Instance<typeof PondStoreModel>
export interface PondStore extends PondStoreType {}
type PondStoreSnapshotType = SnapshotOut<typeof PondStoreModel>
export interface PondStoreSnapshot extends PondStoreSnapshotType {}
export const createPondStoreDefaultModel = () => types.optional(PondStoreModel, {})
